//src/app/features/questionnaires/components/MainWizardSteps/index.tsx
import { CheckedIcon } from 'assets/icons';
import { StepWizardChildProps } from 'react-step-wizard';

export interface IMainWizardStepsProps {
  steps: string[];
}

export default function MainWizardSteps(
  props: IMainWizardStepsProps & Partial<StepWizardChildProps>,
) {
  const { steps, totalSteps, currentStep } = props;
  const activeStep = (i: number) => currentStep === i + 1;
  const completedStep = (i: number) => currentStep! > i + 1;
  return (
    <div className="flex -mt-10 w-full mb-8 md-max:gap-4 md-max:overflow-x-auto no-scrollbar">
      {steps.map((step, i) => (
        <div
          key={i}
          className={`flex-1 flex items-start border-t-4 ${
            completedStep(i) ? 'border-green' : 'border-gray-100'
          } pt-10`}
        >
          <div>{completedStep(i) && <CheckedIcon className="mr-4 mt-2" />}</div>
          <div>
            <p
              className={`${
                activeStep(i) || completedStep(i) ? '' : 'text-gray-light'
              } font-semibold text-base mb-1`}
            >
              {step}
            </p>
            <p
              className={`${
                activeStep(i) || completedStep(i)
                  ? 'text-green'
                  : 'text-gray-light'
              } text-tiny`}
            >
              Step {i + 1} of {totalSteps}
            </p>
          </div>
        </div>
      ))}
    </div>
  );
}
